<script setup lang="ts">

import Login from '@app/components/login/login.vue';
import { AuthManager, LoginPageProps } from '@utils/PanelManager/AuthManager';

const props = defineProps<LoginPageProps>();

const manager = new AuthManager({ ...props });
manager.init();

</script>
<template>
    <Login></Login>
</template>
